(function () {
  if (window.hmT) return;

  function interpolate(str, vars) {
    if (!str || !vars) return str || '';
    return String(str).replace(/\{\{\s*(\w+)\s*\}\}/g, function (_m, key) {
      return vars[key] != null ? String(vars[key]) : '';
    });
  }

  window.hmT = function hmT(path, vars) {
    var root = window.happymamiI18n || {};
    var parts = String(path || '').split('.');
    var node = root;
    for (var i = 0; i < parts.length; i++) {
      if (!node) break;
      node = node[parts[i]];
    }
    if (typeof node !== 'string') return '';
    return interpolate(node, vars);
  };

  window.hmStorefrontLang = function hmStorefrontLang() {
    var fromPage = window.happymamiI18n && window.happymamiI18n.lang;
    if (fromPage) return fromPage;
    var raw = (document.documentElement.lang || 'es').toLowerCase().replace('_', '-');
    var first = raw.split('-')[0];
    if (raw === 'pt-br' || first === 'pt') return 'pt-pt';
    if (first === 'en' || first === 'fr' || first === 'de' || first === 'it' || first === 'es') return first;
    return 'es';
  };
})();
